import React from 'react';
import PropTypes from 'prop-types';

import ImportList from '../ImportList';

const ImporterModalImportList = ({ importer, ...props }) => {
  if (!(importer && importer.connected)) {
    return null;
  }

  return (
    <div>
      <ImportList importer={importer} {...props} />
    </div>
  );
};

ImporterModalImportList.propTypes = {
  importer: PropTypes.object,
};

ImporterModalImportList.defaultProps = {
  importer: null,
};

export default ImporterModalImportList;
